// @flow

import React, { Component } from "react";
import { NavHashLink as NavLink } from "react-router-hash-link";

import LeftIndicator from "../LeftIndicator";
import Movie from "../Movie";
import TechnicalCard from "../TechnicalCard";
import ResponsiveImage from "../ResponsiveImage";
import {
  Accordion,
  AccordionItem,
  AccordionItemState,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';


import "./RoofStep1.scss";
export default class RoofStep1 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: false
    };
  }

  toggleMenu() {
    this.setState({
      menu: !this.state.menu
    });
  }

  closeMenu() {
    this.setState({
      menu: false
    });
  }

getClosestParent(element, selector) {
  	// Element.matches() polyfill
	if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        ((s) => {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                i = matches.length;
            while (--i >= 0 && matches.item(i) !== this) {}
            return i > -1;
        });
}

  // Get the closest matching element
  for ( ; element && element !== document; element = element.parentNode ) {
    if ( element.matches( selector ) ) return element;
  }
  return null;

}

  handleClic(event)  {
    console.log(event.target);
    let parent = this.getClosestParent(event.target, '.accordion__item');
    let activeItems = document.querySelectorAll(".active-acc__item");
    activeItems.forEach(item => item.classList.remove("active-acc__item"));
    parent.classList.add("active-acc__item");
  }

  render() {
    return (
      <React.Fragment>
        <section id="roof-step1" className="roof-step1">
          <div className="roof-step1_container container row">
            <div className="col-6 col-ml-12 photo-col">
              <div className="logo-wrapper">
                <img
                  className="evomer-logo"
                  src="/img/evomer-logo.svg"
                  alt="Evomer logo"
                />
              </div>
               <ResponsiveImage imageName="Szybki-Grunt.jpg" imageClass={"picture"} />
             {/*  <img src="/img/1200/800/Szybki-Grunt.jpg" alt="step-1 bg" className="picture" /> */}
              <div className="indicator-wrapper">
                 {/* <LeftIndicator  fastGround/>  */}
              </div>
            </div>
            <div className="col-6 col-ml-12 roof-photo-description">
              <div className="roof-description-background">
                <p className="h1-white-big">Krok 1</p>
                <p className="h3-red">Szybkie gruntowanie</p>
                <p className="description-title-white">
                  Szybki grunt{" "}
                  <span className="small-title__white">
                    polimerowo-bitumiczny
                  </span>
                </p>
                <p className="text-basic">
                  Przed przystąpieniem do gruntowania należy usunąć z
                  powierzchni pokrycia tłuste zabrudzenia (smary, oleje), rdzę i
                  zanieczyszczenia w tym mechaniczne (piasek, liście itp.).
                </p>
                <p className="text-basic">
                  Zależnie od wielkości powierzchni, Evomer Grunt możemy nanosić
                  pędzlem, wałkiem lub natryskowo. Preparat nadaje się do
                  stosowania na różne powierzchnie, w tym powłoki mineralne,
                  drewno i metal. Zależnie od chłonności podłoża, temperatury i
                  wilgotności względnej,
                </p>
                <p className="text-basic">
                  <p className="white-bold__description">
                    czas schnięcia gruntu{" "}
                  </p>{" "}
                  waha się od
                  <div className="text-important">20 min. </div> (beton, +23 st.
                  C, 50%) do
                  <div className="text-important">1 godz. </div> (beton, +5 st.
                  C, 50%).
                </p>
                <p className="text-basic">
                  W sprzyjających warunkach po 20 min. od zagruntowania, możemy
                  rozpocząć następny etap renowacji.
                </p>
              </div>
            </div>
          </div>

          <div className="prepare-surface  row">
            <div className="container logo-title">
              <div className="logo-title__wrapper flex-title">
                <img src="/img/evomer-logo-white.png" className="logo-white" />
                <p className="h3-red left-margin">Szybkie gruntowanie</p>
              </div>
            </div>
            <div className="prep-surface__container">
              <div className="indicator-container">
                 {/* <LeftIndicator  fastGround/>  */}
              </div>
              <div className="container surface-pics__container">
                <div className="col-12 surface-pictures movie-row row">
                  <div className="col-12 col-ml-12 movie-col">
                    <Movie
                      videoURL="../movies/step1.mp4"
                      image="../img/Szybki-Grunt-movie.jpg"
                    />
                    <div className="col-12 advice">
                      <p className="advice-title-roof">Rada fachowca</p>
                      <p className="advice-text">
                        Powinniśmy pamiętać, że gruntu Evomer nie można nanosić
                        na podłoża zmrożone lub oszronione. Powierzchnia dachu
                        może być wilgotna, ale bez zastoin wody. Bezwzględnie
                        należy też usunąć spękane, luźno związane elementy
                        podłoża oraz naloty roślinne (mchy, porosty). Jeżeli
                        występują pęcherze i pęknięcia papy, nacinamy je i
                        usuwamy.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="fastGroundArea" className="col-12 technical-card fast-ground__wrapper">
              <div className="container logo-title">
                <div className="logo-title__wrapper">
                  <img
                    src="/img/evomer-logo-white.png"
                    className="logo-white"
                  />
                  <div className="sub-title__ccontainer">
                    <p className="h3-red fast-ground">Szybki grunt</p>
                    <p className="description-title-white">
                      Polimerowo-bitumiczny
                    </p>
                  </div>
                </div>
              </div>
              <div className="fast-ground__container">
               {/*  <div className="indicator-wrapper">
                 <LeftIndicator fastGround />
                </div> */}
                <div className="col-12 selects-wrapper container row">
                  <div className="col-6 col-ml-12 selects ">
                    <div className="selects-container">
                    <Accordion>

                        <AccordionItem>

                            <AccordionItemHeading onClick={this.handleClic.bind(this)}>
                                <AccordionItemButton>
                                <span className="af-icon-plus visible-icon"></span><span className="af-icon-minus hidden-icon"></span>Benefity

                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <ul className="benefits-list">
                                <li className="list-item">szybkoschnący i odporny na deszcz – już po 20 minutach</li>
                                <li className="list-item">bezpieczny dla styropianu</li>
                                <li className="list-item">nie zawiera rozpuszczalników – niepalny, bezwonny</li>
                                <li className="list-item">bardzo dobra przyczepność</li>
                                <li className="list-item">wysokowydajny – do 120 m2 (dla opakowania 18kg)</li>
                                <li className="list-item">do stosowania również na powierzchniach wilgotnych</li>
                                <li className="list-item">kompatybilny z materiałami bitumicznymi, mineralnymi</li>
                                <li className="list-item">przyjazny środowisku – nie zawiera rozpuszczalników organicznych</li>
                                </ul>
                            </AccordionItemPanel>

                            </AccordionItem>

                        <AccordionItem>
                            <AccordionItemHeading  onClick={this.handleClic.bind(this)}>
                                <AccordionItemButton>
                                <span className="af-icon-plus visible-icon"></span><span className="af-icon-minus hidden-icon"></span>Sposób aplikacji
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <h5 className="small-header">Przygotowanie produktu</h5>
                                <p className="acc__para">Produkt gotowy do użytku, ale dopuszczalne jest rozcieńczenie wodą w proporcjach 1:1 do 1:2 (jedna cześć gruntu Evomer do dwóch części wody) dla podłoży chłonnych. Przed użyciem dobrze wymieszać.</p>

                                <h5 className="small-header">Przygotowanie podłoża</h5>
                                <p className="acc__para">Podłoże przed aplikacją należy odpylić, elementy niezwiązane usunąć, zabezpieczyć pęknięcia i ubytki. Powierzchnia powinna być wolna od smarów, tłustych zabrudzeń i rdzy. W tym celu powierzchnie gładkie zaleca się przemyć wodą z detergentem, rozpuszczalnikiem lub zmatowić za pomocą szczotki drucianej. Podłoże nie może być zmrożone, oszronione. Może być wilgotne, ale nie mokre. Musi być pozbawione zastoin wody. Należy usunąć luźne elementy, ostre krawędzie, zanieczyszczenia i pył, części metalowe odrdzewić. W wypadku gruntowania pap nawierzchniowych z posypką mineralną, należy usunąć nadmiar niezwiązanej posypki, a także mchy i porosty oraz inne naloty zmniejszające przyczepność.</p>

                                <h5 className="small-header">Aplikacja – Gruntowanie</h5>
                                <p className="acc__para">Grunt należy nanosić na oczyszczone podłoże za pomocą szczotki, pędzla, wałka lub za pomocą natrysku hydrodynamicznego.</p>

                                <h5 className="small-header"> Powłoka izolacyjna</h5>
                                  <ul className="benefits-list ">
                                    <li className="list-item">Nałożyć 2 warstwy zwiększając ilość masy do 0,3 kg/m2/każdą warstwę</li>
                                    <li className="list-item">Aplikacja przy użyciu szczotki, pędzla, wałka lub za pomocą natrysku hydrodynamicznego</li>
                                    <li className="list-item">Drugą warstwę nanosić po przeschnięciu pierwszej, tak by jej nie uszkodzić</li>
                                  </ul>
                              <h5 className="small-header">Parametry natrysku hydrodynamicznego</h5>
                                <p className="acc__para">Natrysk hydrodynamiczny (airless)</p>
                                <p className="acc__para">Agregat o wydajności 2,3l/min</p>
                                <p className="acc__para">Dysza o otworze 0,019” (0,48mm)</p>
                                <p className="acc__para">Ciśnienie aplikacji 150 bar.</p>
                            </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemHeading  onClick={this.handleClic.bind(this)}>
                                <AccordionItemButton>
                                  <span className="af-icon-plus visible-icon"></span><span className="af-icon-minus hidden-icon"></span> Dane techniczne
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <div className="table-wrapper">
                                <table>
                                  <tbody>
                                  <tr>
                                  <td>Podłoże</td>
                                  <td>Blacha, OSB</td>
                                  <td>Beton, ceramika, papa, styropian, XPS</td>
                                  <td>Stara papa, renowacja powłok bitumicznych,<br />
                                  tynki mineralne i cem.-wapienne</td>
                                  </tr>
                                  <tr>
                                  <td>Rozcieńczenie</td>
                                  <td>Nie rozcieńczać</td>
                                  <td>1:1</td>
                                  <td>1:2</td>
                                  </tr>
                                  <tr>
                                  <td>Zużycie kg/m2</td>
                                  <td>0,2</td>
                                  <td>0,15</td>
                                  <td>0,15</td>
                                  </tr>
                                  <tr>
                                  <td>Wydajność z opakowania 18 kg</td>
                                  <td>90 m<sup>2</sup></td>
                                  <td>120 m<sup>2</sup></td>
                                  <td>120 m<sup>2</sup></td>
                                  </tr>
                                  <tr>
                                  <td>Wydajność z opakowania 9 kg</td>
                                  <td>45 m<sup>2</sup></td>
                                  <td>60 m<sup>2</sup></td>
                                  <td>60 m<sup>2</sup></td>
                                  </tr>
                                  </tbody>
                                  </table>
                                </div>
                            </AccordionItemPanel>
                        </AccordionItem>
                    </Accordion>
                    </div>

                    <TechnicalCard
                      pdf={
                        "/pdf/evomer-szybki-grunt-01-TDS-Karta-techniczna-produktu.pdf"
                      }
                    />
                  </div>
                  <div className="col-6 col-ml-12  roof-product">
                    <img
                      src="/img/szybki-grunt-produkt.png"
                      className="product-large"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RoofStep1/RoofStep1.js